/* eslint-disable no-var */
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '../../../../../components/card/card';
import Breadcrumb from '../../../../../components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { GetMasterItemsById, cleanUpMasterItemsById } from '../../../../../store/INV/MasterItems/MasterItemsSlice';
import ItemConversion from './ItemConversion';
import Loading from '../../../../../components/Shared/Loader/Loading';
import AssignmentItemToMultiInventories from './AssignmentItemToMultiInventories';
import LotItem from './LotItems/LotItem';
import AlternativeItems from './AlternativeItems';
import Update from './Update';
import Attributes from './Attributes';
import ItemsSupplier from './ItemsSupplier';
import ItemImage from './ItemImage';

const MasterItemsDetails = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { ItemId } = useParams();

  useEffect(() => {
    if (ItemId) {
      dispatch(GetMasterItemsById(ItemId));
    }
    return () => {
      dispatch(cleanUpMasterItemsById());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { MasterItemsById } = useAppSelector(a => a.MasterItemsINV);

  // const { UnitsOfMeasureList } = useGetUnitsOfMeasureList();

  //________________________________

  return (
    <>
      <>
      <div className='d-flex align-items-center  '>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: t('Home'),
             link: ':moduleHome'
            },
            {
              name: t('Items'),
              link: '/INV/InventorySettings/MasterItems'
            },
            {
              name: t('ItemDetails'),
              link: null
            }
          ]}
          PageName={t('ItemDetails')}
          subtitle={i18n.language === 'en' ? MasterItemsById.name : MasterItemsById.name2}
        />
      </div>

      <Loading loading={false} error={null}>
        <div className='  '>
          <div className='row gx-4 gy-4 mb-4'>
            <div className='col-12'>
              <>
                <Card>
                  <CardHeader className='d-flex align-items-center justify-content-between fw-bold small bg-theme bg-opacity-25'>
                    <div className='fw-bold'>
                      <i className='fas fa-info-circle me-2'></i>
                      {t('ItemData')}
                    </div>
                  </CardHeader>
                  <CardBody>
                    <Update />
                  </CardBody>
                </Card>
              </>
            </div>
          </div>

          <div className='row gx-3 gy-3'>
            <div className='col-12 col-lg-8'>
              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-boxes me-2'></i>
                    {t('ItemUnits')}
                  </CardHeader>
                  <CardBody>
                    <ItemConversion />
                  </CardBody>
                </Card>
              </>

              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-hashtag me-2'></i>
                    {t('LotNumbers')}
                  </CardHeader>
                  <CardBody>
                    <LotItem />
                  </CardBody>
                </Card>
              </>

              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-retweet me-2'></i>
                    {t('ItemAttributes')}
                  </CardHeader>
                  <CardBody>
                    <Attributes />
                  </CardBody>
                </Card>
              </>
            </div>

            <div className='col-12 col-lg-4'>
              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-image me-2'></i>
                    {t('ProductImage')}
                  </CardHeader>
                  <CardBody>
                    <ItemImage img={MasterItemsById?.imagee?.filePath} />
                  </CardBody>
                </Card>
              </>

              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-warehouse me-2'></i>
                    {t('Inventory')}
                  </CardHeader>
                  <CardBody>
                    <AssignmentItemToMultiInventories />
                  </CardBody>
                </Card>
              </>

              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-retweet me-2'></i>
                    {t('AlternativeItems')}
                  </CardHeader>
                  <CardBody>
                    <AlternativeItems />
                  </CardBody>
                </Card>
              </>

              <>
                <Card className='mb-3'>
                  <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
                    <i className='fas fa-retweet me-2'></i>
                    {t('ItemSuppliers')}
                  </CardHeader>
                  <CardBody>
                    <ItemsSupplier />
                  </CardBody>
                </Card>
              </>
            </div>
          </div>
        </div>
      </Loading>
    </>

    </>
  );
};

export default MasterItemsDetails;

// <>
//   <div className='d-flex align-items-center'>
//     <Breadcrumb
//       BreadcrumbList={BcrumbList}
//       PageName={t('تفاصيل الصنف')}
//       subtitle={i18n.language === 'en' ? MasterItemsById.name : MasterItemsById.name2}
//     />
//   </div>

//   <Loading loading={false} error={null}>
//     <>
//       <div className='row gx-4'>
//         <div className='col-lg-12'>
//           <Fade>
//             <Card className='mb-4'>
//               <CardHeader className='d-flex align-items-center justify-content-between fw-bold small bg-theme bg-opacity-25'>
//                 <div className='fw-bold'>
//                   <i className='fas fa-info-circle me-2'></i>
//                   تفاصيل المنتج
//                 </div>
//               </CardHeader>
//               <CardBody>
//                 <Update />
//               </CardBody>
//             </Card>
//           </Fade>
//         </div>
//       </div>

//       <div className='row gx-4'>
//         <div className='col-lg-8'>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-boxes me-2'></i>
//                   وحدات الصنف
//                 </CardHeader>
//                 <CardBody>
//                   <ItemConversion />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-hashtag me-2'></i>
//                   أرقام التشغيل
//                 </CardHeader>
//                 <CardBody>
//                   <LotItem />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-retweet me-2'></i>
//                   سمات الصنف
//                 </CardHeader>
//                 <CardBody>
//                   <Attributes />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//         </div>

//         <div className='col-lg-4'>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-image me-2'></i>
//                   صورة المنتج
//                 </CardHeader>
//                 <CardBody>
//                   <ItemImage />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-warehouse me-2'></i>
//                   المخزن
//                 </CardHeader>
//                 <CardBody>
//                   <AssignmentItemToMultiInventories />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-retweet me-2'></i>
//                   الأصناف البديـلة
//                 </CardHeader>
//                 <CardBody>
//                   <AlternativeItems />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//           <div className='col-lg-12'>
//             <Fade>
//               <Card className='mb-4'>
//                 <CardHeader className='d-flex align-items-center fw-bold small bg-theme bg-opacity-25'>
//                   <i className='fas fa-retweet me-2'></i>
//                   موردين الصنف
//                 </CardHeader>
//                 <CardBody>
//                   <ItemsSupplier />
//                 </CardBody>
//               </Card>
//             </Fade>
//           </div>
//         </div>
//       </div>
//     </>
//   </Loading>
// </>
